import { atom } from 'jotai'

export interface User {
  email: string
  role: 'sales' | 'client_success' | 'resume_writer' | 'coach' | 'admin' | 'client'
  name?: string
  clientId?: string // Only for client role - links user to their client record
  isManager?: boolean // Grants admin-level permissions when true
}

export const userAtom = atom<User | null>(null)
export const isLoadingAtom = atom<boolean>(true)
